import { DatePipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';
import { ConstantsService } from '../constants/constants.service';

@Pipe({
  name: 'dateFormat',
  standalone: true
})
export class DateFormatPipe implements PipeTransform {

  constructor(private datePipe: DatePipe, private constantsService: ConstantsService) {}

  transform(value: Date | string | number): string | null {
    const format = this.constantsService.DATE_FORMAT;
    return this.datePipe.transform(value, format);
  }
}
